/* eslint-disable no-loss-of-precision */
import Hair118back from '../Hair/Hair118back'
import Hair33back from '../Hair/Hair33back'
import Hair55back from '../Hair/Hair55back'
import Hair02back from '../Hair/Hair02back'
import Hair14back from '../Hair/Hair14back'
import Hair76back from '../Hair/Hair76back'
import Hair03back from '../Hair/Hair03back'
import Hair11back from '../Hair/Hair11back'
import Hair15back from '../Hair/Hair15back'
import Hair57back from '../Hair/Hair57back'
import Hair77back from '../Hair/Hair77back'
import Hair16back from '../Hair/Hair16back'
import Hair38back from '../Hair/Hair38back'
import Hair58back from '../Hair/Hair58back'
import Hair78back from '../Hair/Hair78back'
import Hair17back from '../Hair/Hair17back'
import Hair39back from '../Hair/Hair39back'
import Hair59back from '../Hair/Hair59back'
import Hair07back from '../Hair/Hair07back'
import Hair80back from '../Hair/Hair80back'
import Hair124back from '../Hair/Hair124back'
import Hair18back from '../Hair/Hair18back'
import Hair40back from '../Hair/Hair40back'
import Hair60back from '../Hair/Hair60back'
import Hair81back from '../Hair/Hair81back'
import Hair09back from '../Hair/Hair09back'
import Hair19back from '../Hair/Hair19back'
import Hair41back from '../Hair/Hair41back'
import Hair127back from '../Hair/Hair127back'
import Hair42back from '../Hair/Hair42back'
import Hair63back from '../Hair/Hair63back'
import Hair43back from '../Hair/Hair43back'
import Hair64back from '../Hair/Hair64back'
import Hair22back from '../Hair/Hair22back'
import Hair12back from '../Hair/Hair12back'
import Hair65back from '../Hair/Hair65back'
import Hair23back from '../Hair/Hair23back'
import Hair45back from '../Hair/Hair45back'
import Hair106back from '../Hair/Hair106back'
import Hair66back from '../Hair/Hair66back'
import Hair46back from '../Hair/Hair46back'
import Hair131back from '../Hair/Hair131back'
import Hair24back from '../Hair/Hair24back'
import Hair67back from '../Hair/Hair67back'
import Hair47back from '../Hair/Hair47back'
import Hair25back from '../Hair/Hair25back'
import Hair68back from '../Hair/Hair68back'
import Hair10back from '../Hair/Hair10back'
import Hair133back from '../Hair/Hair133back'
import Hair48back from '../Hair/Hair48back'
import Hair26back from '../Hair/Hair26back'
import Hair69back from '../Hair/Hair69back'
import Hair95back from '../Hair/Hair95back'
import Hair49back from '../Hair/Hair49back'
import Hair27back from '../Hair/Hair27back'
import Hair70back from '../Hair/Hair70back'
import Hair112back from '../Hair/Hair112back'
import Hair50back from '../Hair/Hair50back'
import Hair97back from '../Hair/Hair97back'
import Hair71back from '../Hair/Hair71back'
import Hair113back from '../Hair/Hair113back'
import Hair51back from '../Hair/Hair51back'
import Hair71front from '../Hair/Hair71front'
import Hair98back from '../Hair/Hair98back'
import Hair139back from '../Hair/Hair139back'
import Hair30back from '../Hair/Hair30back'
import Hair72back from '../Hair/Hair72back'
import Hair114back from '../Hair/Hair114back'
import Hair52back from '../Hair/Hair52back'
import Hair73back from '../Hair/Hair73back'
import Hair32back from '../Hair/Hair32back'
import Hair54back from '../Hair/Hair54back'
import Hair75back from '../Hair/Hair75back'

const data = [
  {
    id: 'Hair02back',
    svg: Hair02back,
    positioning: {
      pointNarrow: {
        y: 87.6904296875,
        scaleX: 1,
      },
      pointMedium: {
        y: 83.1529541015625,
        scaleX: 1,
      },
      pointWide: {
        y: 93.53709411621094,
        scaleX: 1.2,
      },
      roundNarrow: {
        y: 87.3480224609375,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 82.76565551757812,
        scaleX: 1,
      },
      roundWide: {
        y: 81.50093078613281,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 87.34884643554688,
        scaleX: 1,
      },
      squareMedium: {
        y: 88.67701721191406,
        scaleX: 1,
      },
      squareWide: {
        y: 79.83882904052734,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair03back',
    svg: Hair03back,
    positioning: {
      pointNarrow: {
        y: 89.57356262207031,
        scaleX: 1,
      },
      pointMedium: {
        y: 91.14839172363281,
        scaleX: 1,
      },
      pointWide: {
        y: 97.98748779296875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 95.42158508300781,
        scaleX: 1,
      },
      roundMedium: {
        y: 86.77386474609375,
        scaleX: 1,
      },
      roundWide: {
        y: 86.89093017578125,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 92.55070495605469,
        scaleX: 1,
      },
      squareMedium: {
        y: 90.98196411132812,
        scaleX: 1,
      },
      squareWide: {
        y: 84.8651123046875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair07back',
    svg: Hair07back,
    positioning: {
      pointNarrow: {
        y: 38,
        scaleX: 1,
      },
      pointMedium: {
        y: 38.7325439453125,
        scaleX: 1,
      },
      pointWide: {
        y: 36,
        scaleX: 1,
      },
      roundNarrow: {
        y: 38,
        scaleX: 1,
      },
      roundMedium: {
        y: 38,
        scaleX: 1,
      },
      roundWide: {
        y: 36,
        scaleX: 1,
      },
      squareNarrow: {
        y: 38,
        scaleX: 1,
      },
      squareMedium: {
        y: 38,
        scaleX: 1,
      },
      squareWide: {
        y: 38,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair09back',
    svg: Hair09back,
    positioning: {
      pointNarrow: {
        y: 58.57313537597656,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 61.51808166503906,
        scaleX: 1,
      },
      pointWide: {
        y: 52.083740234375,
        scaleX: 0.95,
      },
      roundNarrow: {
        y: 63.278770446777344,
        scaleX: 0.8,
      },
      roundMedium: {
        y: 57.167633056640625,
        scaleX: 0.85,
      },
      roundWide: {
        y: 56.301239013671875,
        scaleX: 0.95,
      },
      squareNarrow: {
        y: 61.45256042480469,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 64.12353515625,
        scaleX: 0.9,
      },
      squareWide: {
        y: 56.95904541015625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair106back',
    svg: Hair106back,
    positioning: {
      pointNarrow: {
        y: 113.9403076171875,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 82.99015808105469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair10back',
    svg: Hair10back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 107.52894592285156,
        scaleX: 1,
      },
      roundMedium: {
        y: 110.37503051757812,
        scaleX: 1,
      },
      roundWide: {
        y: 124.22224426269531,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 108.13308715820312,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair112back',
    svg: Hair112back,
    positioning: {
      pointNarrow: {
        y: 91.33352661132812,
        scaleX: 1.07,
      },
      pointMedium: {
        y: 97.95936584472656,
        scaleX: 1.2,
      },
      pointWide: {
        y: 98.32861328125,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 92.64427185058594,
        scaleX: 1.05,
      },
      roundMedium: {
        y: 100,
        scaleX: 1.3,
      },
      roundWide: {
        y: 96.86766052246094,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 100.69931030273438,
        scaleX: 1.12,
      },
      squareMedium: {
        y: 95.36410522460938,
        scaleX: 1.25,
      },
      squareWide: {
        y: 98.21934509277344,
        scaleX: 1.34,
      },
    },
  },
  {
    id: 'Hair113back',
    svg: Hair113back,
    positioning: {
      pointNarrow: {
        y: 98.13299560546875,
        scaleX: 1,
      },
      pointMedium: {
        y: 100.92129516601562,
        scaleX: 1.15,
      },
      pointWide: {
        y: 98,
        scaleX: 1.2,
      },
      roundNarrow: {
        y: 100.47053527832031,
        scaleX: 1,
      },
      roundMedium: {
        y: 95,
        scaleX: 1.05,
      },
      roundWide: {
        y: 96,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 99.83967590332031,
        scaleX: 1,
      },
      squareMedium: {
        y: 96,
        scaleX: 1.18,
      },
      squareWide: {
        y: 97,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair114back',
    svg: Hair114back,
    positioning: {
      pointNarrow: {
        y: 98.59718322753906,
        scaleX: 1,
      },
      pointMedium: {
        y: 97.89208984375,
        scaleX: 1.1,
      },
      pointWide: {
        y: 94.75491333007812,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 105.3140869140625,
        scaleX: 1,
      },
      roundMedium: {
        y: 95.826904296875,
        scaleX: 1,
      },
      roundWide: {
        y: 93.58335876464844,
        scaleX: 1,
      },
      squareNarrow: {
        y: 96.10260009765625,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 105.59059143066406,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair118back',
    svg: Hair118back,
    positioning: {
      pointNarrow: {
        y: 105.0262451171875,
        scaleX: 1,
      },
      pointMedium: {
        y: 110.28866577148438,
        scaleX: 1,
      },
      pointWide: {
        y: 112.57278442382812,
        scaleX: 1.4,
      },
      roundNarrow: {
        y: 104.41943359375,
        scaleX: 1,
      },
      roundMedium: {
        y: 110.24336242675781,
        scaleX: 1,
      },
      roundWide: {
        y: 111.65318298339844,
        scaleX: 1.4,
      },
      squareNarrow: {
        y: 107.71273803710938,
        scaleX: 1,
      },
      squareMedium: {
        y: 118.17756652832031,
        scaleX: 1,
      },
      squareWide: {
        y: 110.2445068359375,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair11back',
    svg: Hair11back,
    positioning: {
      pointNarrow: {
        y: 102.5743408203125,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 114.14276123046875,
        scaleX: 1,
      },
      pointWide: {
        y: 96.11984252929688,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100.22236633300781,
        scaleX: 1,
      },
      roundMedium: {
        y: 102.52867126464844,
        scaleX: 1,
      },
      roundWide: {
        y: 95.32171630859375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 104.42071533203125,
        scaleX: 1,
      },
      squareMedium: {
        y: 104.7557373046875,
        scaleX: 1,
      },
      squareWide: {
        y: 102.55946350097656,
        scaleX: 1.15,
      },
    },
  },
  {
    id: 'Hair124back',
    svg: Hair124back,
    positioning: {
      pointNarrow: {
        y: 106.17591857910156,
        scaleX: 0.95,
      },
      pointMedium: {
        y: 105.29161071777344,
        scaleX: 1.1,
      },
      pointWide: {
        y: 104.81668090820312,
        scaleX: 1.3,
      },
      roundNarrow: {
        y: 106.67414855957031,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 105.77287292480469,
        scaleX: 1.1,
      },
      roundWide: {
        y: 99.279296875,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 103.40243530273438,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 105.28265380859375,
        scaleX: 1.1,
      },
      squareWide: {
        y: 105.08216857910156,
        scaleX: 1.3,
      },
    },
  },
  {
    id: 'Hair127back',
    svg: Hair127back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 110.0860595703125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 112.99357604980469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair12back',
    svg: Hair12back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair131back',
    svg: Hair131back,
    positioning: {
      pointNarrow: {
        y: 114.08511352539062,
        scaleX: 1,
      },
      pointMedium: {
        y: 116.17787170410156,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 113.15023803710938,
        scaleX: 1,
      },
      roundMedium: {
        y: 118.62806701660156,
        scaleX: 1,
      },
      roundWide: {
        y: 117.94325256347656,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 105.6728515625,
        scaleX: 1,
      },
      squareMedium: {
        y: 116.57313537597656,
        scaleX: 1,
      },
      squareWide: {
        y: 112.42050170898438,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair133back',
    svg: Hair133back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair139back',
    svg: Hair139back,
    positioning: {
      pointNarrow: {
        y: 121.67457580566406,
        scaleX: 1,
      },
      pointMedium: {
        y: 123.24728393554688,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 120.18159484863281,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 120.81120300292969,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair14back',
    svg: Hair14back,
    positioning: {
      pointNarrow: {
        y: 90.842041015625,
        scaleX: 1,
      },
      pointMedium: {
        y: 104.84486389160156,
        scaleX: 1,
      },
      pointWide: {
        y: 93.86868286132812,
        scaleX: 1,
      },
      roundNarrow: {
        y: 96.60440063476562,
        scaleX: 1,
      },
      roundMedium: {
        y: 88.99899291992188,
        scaleX: 1,
      },
      roundWide: {
        y: 101.94172668457031,
        scaleX: 1,
      },
      squareNarrow: {
        y: 88.93775939941406,
        scaleX: 1,
      },
      squareMedium: {
        y: 94.54595947265625,
        scaleX: 1,
      },
      squareWide: {
        y: 85.65449523925781,
        scaleX: 1.25,
      },
    },
  },
  {
    id: 'Hair15back',
    svg: Hair15back,
    positioning: {
      pointNarrow: {
        y: 95,
        scaleX: 1.5,
      },
      pointMedium: {
        y: 92,
        scaleX: 1.75,
      },
      pointWide: {
        y: 100,
        scaleX: 1.8,
      },
      roundNarrow: {
        y: 95,
        scaleX: 1.5,
      },
      roundMedium: {
        y: 92,
        scaleX: 1.65,
      },
      roundWide: {
        y: 100,
        scaleX: 1.8,
      },
      squareNarrow: {
        y: 95,
        scaleX: 1.5,
      },
      squareMedium: {
        y: 92,
        scaleX: 1.75,
      },
      squareWide: {
        y: 100,
        scaleX: 1.8,
      },
    },
  },
  {
    id: 'Hair16back',
    svg: Hair16back,
    positioning: {
      pointNarrow: {
        y: 111.81268310546875,
        scaleX: 1,
      },
      pointMedium: {
        y: 107.02348327636719,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 108.32572937011719,
        scaleX: 1,
      },
      roundMedium: {
        y: 110.53300476074219,
        scaleX: 1,
      },
      roundWide: {
        y: 112.21623229980469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 109.28273010253906,
        scaleX: 1,
      },
      squareMedium: {
        y: 112.74299621582031,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair17back',
    svg: Hair17back,
    positioning: {
      pointNarrow: {
        y: 105,
        scaleX: 1,
      },
      pointMedium: {
        y: 110.90716552734375,
        scaleX: 1,
      },
      pointWide: {
        y: 110,
        scaleX: 1,
      },
      roundNarrow: {
        y: 104.31916809082031,
        scaleX: 1,
      },
      roundMedium: {
        y: 105.80270385742188,
        scaleX: 1,
      },
      roundWide: {
        y: 110,
        scaleX: 1,
      },
      squareNarrow: {
        y: 110,
        scaleX: 0.95,
      },
      squareMedium: {
        y: 110,
        scaleX: 0.95,
      },
      squareWide: {
        y: 116.60902404785156,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair18back',
    svg: Hair18back,
    positioning: {
      pointNarrow: {
        y: 100.60540771484375,
        scaleX: 1,
      },
      pointMedium: {
        y: 105.98089599609375,
        scaleX: 1,
      },
      pointWide: {
        y: 102.80780029296875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 104.56524658203125,
        scaleX: 1,
      },
      roundMedium: {
        y: 103.24234008789062,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 101.78643798828125,
        scaleX: 1,
      },
      squareMedium: {
        y: 101.78817749023438,
        scaleX: 1,
      },
      squareWide: {
        y: 104.35884094238281,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair19back',
    svg: Hair19back,
    positioning: {
      pointNarrow: {
        y: 80.41641235351562,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 80.3685302734375,
        scaleX: 1,
      },
      pointWide: {
        y: 80.99349975585938,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 80,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 80.23260498046875,
        scaleX: 1,
      },
      roundWide: {
        y: 84.27206420898438,
        scaleX: 1,
      },
      squareNarrow: {
        y: 80.8148193359375,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 80,
        scaleX: 0.87,
      },
      squareWide: {
        y: 80.97383117675781,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair22back',
    svg: Hair22back,
    positioning: {
      pointNarrow: {
        y: 103.10002136230469,
        scaleX: 1,
      },
      pointMedium: {
        y: 117.47303771972656,
        scaleX: 1,
      },
      pointWide: {
        y: 103.96234130859375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 107.83604431152344,
        scaleX: 1,
      },
      roundMedium: {
        y: 113.43820190429688,
        scaleX: 1,
      },
      roundWide: {
        y: 94.58912658691406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 102.67141723632812,
        scaleX: 1,
      },
      squareMedium: {
        y: 112.94602966308594,
        scaleX: 1,
      },
      squareWide: {
        y: 111.9937744140625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair23back',
    svg: Hair23back,
    positioning: {
      pointNarrow: {
        y: 110.86451721191406,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 110.11358642578125,
        scaleX: 0.7,
      },
      pointWide: {
        y: 110.08390808105469,
        scaleX: 0.7,
      },
      roundNarrow: {
        y: 110.22682189941406,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 110,
        scaleX: 0.7,
      },
      roundWide: {
        y: 110.49415588378906,
        scaleX: 1,
      },
      squareNarrow: {
        y: 110.14773559570312,
        scaleX: 0.7,
      },
      squareMedium: {
        y: 110,
        scaleX: 0.7,
      },
      squareWide: {
        y: 110,
        scaleX: 0.7,
      },
    },
  },
  {
    id: 'Hair24back',
    svg: Hair24back,
    positioning: {
      pointNarrow: {
        y: 95.96682739257812,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 89.71966552734375,
        scaleX: 0.9,
      },
      pointWide: {
        y: 98.04951477050781,
        scaleX: 1,
      },
      roundNarrow: {
        y: 98.86801147460938,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 104.50077819824219,
        scaleX: 0.9,
      },
      roundWide: {
        y: 88.71719360351562,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90.58734130859375,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 103.72447204589844,
        scaleX: 0.9,
      },
      squareWide: {
        y: 88.619873046875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair25back',
    svg: Hair25back,
    positioning: {
      pointNarrow: {
        y: 80.6595458984375,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 80.095458984375,
        scaleX: 0.85,
      },
      pointWide: {
        y: 80.93283081054688,
        scaleX: 1,
      },
      roundNarrow: {
        y: 80.36691284179688,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 80.11502075195312,
        scaleX: 0.9,
      },
      roundWide: {
        y: 83.64288330078125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 80.84140014648438,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 80.1455078125,
        scaleX: 0.875,
      },
      squareWide: {
        y: 80,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair26back',
    svg: Hair26back,
    positioning: {
      pointNarrow: {
        y: 71,
        scaleX: 0.7,
      },
      pointMedium: {
        y: 73,
        scaleX: 0.85,
      },
      pointWide: {
        y: 80,
        scaleX: 1.05,
      },
      roundNarrow: {
        y: 70,
        scaleX: 0.7,
      },
      roundMedium: {
        y: 72,
        scaleX: 0.85,
      },
      roundWide: {
        y: 78,
        scaleX: 1,
      },
      squareNarrow: {
        y: 74,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 76,
        scaleX: 0.85,
      },
      squareWide: {
        y: 80,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair27back',
    svg: Hair27back,
    positioning: {
      pointNarrow: {
        y: 68.431640625,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 74.9350357055664,
        scaleX: 0.85,
      },
      pointWide: {
        y: 73.25325775146484,
        scaleX: 1,
      },
      roundNarrow: {
        y: 74.40912628173828,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 68.9112319946289,
        scaleX: 0.95,
      },
      roundWide: {
        y: 71.794677734375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 73.16053771972656,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 68.88578796386719,
        scaleX: 1,
      },
      squareWide: {
        y: 68.25181579589844,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair30back',
    svg: Hair30back,
    positioning: {
      pointNarrow: {
        y: 98.22207641601562,
        scaleX: 1,
      },
      pointMedium: {
        y: 101.4364013671875,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100.74017333984375,
        scaleX: 1,
      },
      roundMedium: {
        y: 105.21366882324219,
        scaleX: 1,
      },
      roundWide: {
        y: 105,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair32back',
    svg: Hair32back,
    positioning: {
      pointNarrow: {
        y: 100.50790405273438,
        scaleX: 1,
      },
      pointMedium: {
        y: 95.57833862304688,
        scaleX: 1,
      },
      pointWide: {
        y: 89.91278076171875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 102.81552124023438,
        scaleX: 1,
      },
      roundMedium: {
        y: 104.80061340332031,
        scaleX: 1,
      },
      roundWide: {
        y: 94.59271240234375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 105.59344482421875,
        scaleX: 1,
      },
      squareMedium: {
        y: 108.34809875488281,
        scaleX: 1,
      },
      squareWide: {
        y: 101.63424682617188,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair33back',
    svg: Hair33back,
    positioning: {
      pointNarrow: {
        y: 70.19375610351562,
        scaleX: 0.775,
      },
      pointMedium: {
        y: 70.91824340820312,
        scaleX: 0.9,
      },
      pointWide: {
        y: 70.87847900390625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 70.8612060546875,
        scaleX: 0.775,
      },
      roundMedium: {
        y: 70.58302307128906,
        scaleX: 0.85,
      },
      roundWide: {
        y: 73.10040283203125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 70.73966979980469,
        scaleX: 0.775,
      },
      squareMedium: {
        y: 70.45390319824219,
        scaleX: 0.9,
      },
      squareWide: {
        y: 70.033935546875,
        scaleX: 0.95,
      },
    },
  },
  {
    id: 'Hair38back',
    svg: Hair38back,
    positioning: {
      pointNarrow: {
        y: 104.52203369140625,
        scaleX: 1,
      },
      pointMedium: {
        y: 120.2083740234375,
        scaleX: 1,
      },
      pointWide: {
        y: 101.14288330078125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 114.13934326171875,
        scaleX: 1,
      },
      roundMedium: {
        y: 102.96601867675781,
        scaleX: 1,
      },
      roundWide: {
        y: 102.95082092285156,
        scaleX: 1,
      },
      squareNarrow: {
        y: 99.50871276855469,
        scaleX: 1,
      },
      squareMedium: {
        y: 120.54576110839844,
        scaleX: 1,
      },
      squareWide: {
        y: 102.90641784667969,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair39back',
    svg: Hair39back,
    positioning: {
      pointNarrow: {
        y: 48,
        scaleX: 1,
      },
      pointMedium: {
        y: 43.27103042602539,
        scaleX: 1,
      },
      pointWide: {
        y: 38.964630126953125,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 44,
        scaleX: 0.95,
      },
      roundMedium: {
        y: 48,
        scaleX: 1,
      },
      roundWide: {
        y: 35.54509735107422,
        scaleX: 1.1,
      },
      squareNarrow: {
        y: 48,
        scaleX: 1,
      },
      squareMedium: {
        y: 43,
        scaleX: 1,
      },
      squareWide: {
        y: 43,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair40back',
    svg: Hair40back,
    positioning: {
      pointNarrow: {
        y: 108.30618286132812,
        scaleX: 1,
      },
      pointMedium: {
        y: 109.14347839355469,
        scaleX: 1,
      },
      pointWide: {
        y: 100.51992797851562,
        scaleX: 1,
      },
      roundNarrow: {
        y: 108.99296569824219,
        scaleX: 1,
      },
      roundMedium: {
        y: 110.79475402832031,
        scaleX: 1,
      },
      roundWide: {
        y: 97.91914367675781,
        scaleX: 1,
      },
      squareNarrow: {
        y: 107.32955932617188,
        scaleX: 1,
      },
      squareMedium: {
        y: 111.00595092773438,
        scaleX: 1,
      },
      squareWide: {
        y: 101.0216064453125,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair41back',
    svg: Hair41back,
    positioning: {
      pointNarrow: {
        y: 107,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 110.12994003295898,
        scaleX: 1,
      },
      pointWide: {
        y: 110.54183959960938,
        scaleX: 1,
      },
      roundNarrow: {
        y: 105.76556396484375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 108,
        scaleX: 0.9,
      },
      roundWide: {
        y: 109.59115600585938,
        scaleX: 1,
      },
      squareNarrow: {
        y: 107.72172546386719,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 107.87791442871094,
        scaleX: 0.95,
      },
      squareWide: {
        y: 110.13924598693848,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair42back',
    svg: Hair42back,
    positioning: {
      pointNarrow: {
        y: 102.51248168945312,
        scaleX: 1,
      },
      pointMedium: {
        y: 103.43525695800781,
        scaleX: 1,
      },
      pointWide: {
        y: 100.17803955078125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 105.56159973144531,
        scaleX: 1,
      },
      roundMedium: {
        y: 102.78024291992188,
        scaleX: 1,
      },
      roundWide: {
        y: 91.49797058105469,
        scaleX: 1.05,
      },
      squareNarrow: {
        y: 100.17076110839844,
        scaleX: 1,
      },
      squareMedium: {
        y: 93.8887939453125,
        scaleX: 1,
      },
      squareWide: {
        y: 103.77473449707031,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair43back',
    svg: Hair43back,
    positioning: {
      pointNarrow: {
        y: 45,
        scaleX: 1,
      },
      pointMedium: {
        y: 38.81455993652344,
        scaleX: 1,
      },
      pointWide: {
        y: 31.27301025390625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 45,
        scaleX: 1,
      },
      roundMedium: {
        y: 45,
        scaleX: 1,
      },
      roundWide: {
        y: 22.175010681152344,
        scaleX: 1,
      },
      squareNarrow: {
        y: 45,
        scaleX: 1,
      },
      squareMedium: {
        y: 31.73347496986389,
        scaleX: 1,
      },
      squareWide: {
        y: 45,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair45back',
    svg: Hair45back,
    positioning: {
      pointNarrow: {
        y: 59,
        x: -3,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 57,
        x: -2,
        scaleX: 0.9,
      },
      pointWide: {
        y: 59,
        x: -8,
        scaleX: 1,
      },
      roundNarrow: {
        y: 59,
        x: -3,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 60,
        x: -2,
        scaleX: 0.9,
      },
      roundWide: {
        y: 60,
        x: -8,
        scaleX: 1,
      },
      squareNarrow: {
        y: 60,
        x: -3,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 55,
        x: -3,
        scaleX: 0.9,
      },
      squareWide: {
        y: 60,
        x: -11.5,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair46back',
    svg: Hair46back,
    positioning: {
      pointNarrow: {
        y: 104.21168518066406,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 99.06948852539062,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 97.9208984375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair47back',
    svg: Hair47back,
    positioning: {
      pointNarrow: {
        y: 106.33378601074219,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 99.73468017578125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 106.7435302734375,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 97.41542053222656,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair48back',
    svg: Hair48back,
    positioning: {
      pointNarrow: {
        y: 114.57809448242188,
        scaleX: 1,
      },
      pointMedium: {
        y: 120.25401306152344,
        scaleX: 1,
      },
      pointWide: {
        y: 125.70062255859375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 120.02983093261719,
        scaleX: 1,
      },
      roundMedium: {
        y: 119.16070556640625,
        scaleX: 1,
      },
      roundWide: {
        y: 123.80409240722656,
        scaleX: 1,
      },
      squareNarrow: {
        y: 118.267578125,
        scaleX: 1,
      },
      squareMedium: {
        y: 124.92559814453125,
        scaleX: 1,
      },
      squareWide: {
        y: 114.69181823730469,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair49back',
    svg: Hair49back,
    positioning: {
      pointNarrow: {
        y: 105.13722229003906,
        scaleX: 0.85,
        x: 2.5,
      },
      pointMedium: {
        y: 114.52509307861328,
        scaleX: 0.9,
        x: 3.0,
      },
      pointWide: {
        y: 60.02587890625,
        scaleX: 1,
        x: 3.0,
      },
      roundNarrow: {
        y: 100.80032348632812,
        scaleX: 0.85,
        x: 2.5,
      },
      roundMedium: {
        y: 102.65438842773438,
        scaleX: 0.9,
        x: 3.0,
      },
      roundWide: {
        y: 63.79518127441406,
        scaleX: 1,
        x: 3.0,
      },
      squareNarrow: {
        y: 104.05752563476562,
        scaleX: 0.85,
        x: 2.5,
      },
      squareMedium: {
        y: 105.42866516113281,
        scaleX: 0.9,
        x: 3.0,
      },
      squareWide: {
        y: 110.112548828125,
        scaleX: 1,
        x: 3.0,
      },
    },
  },
  {
    id: 'Hair50back',
    svg: Hair50back,
    positioning: {
      pointNarrow: {
        y: 113.07574462890625,
        scaleX: 1,
      },
      pointMedium: {
        y: 118.15562438964844,
        scaleX: 1,
      },
      pointWide: {
        y: 99.54205322265625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 107.07313537597656,
        scaleX: 1,
      },
      roundMedium: {
        y: 108.67259216308594,
        scaleX: 1,
      },
      roundWide: {
        y: 95.35711669921875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 103.99168395996094,
        scaleX: 1,
      },
      squareMedium: {
        y: 113.59202575683594,
        scaleX: 1,
      },
      squareWide: {
        y: 104.26570129394531,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair51back',
    svg: Hair51back,
    positioning: {
      pointNarrow: {
        y: 106.83303833007812,
        scaleX: 1,
      },
      pointMedium: {
        y: 118.51113891601562,
        scaleX: 1,
      },
      pointWide: {
        y: 104.70712280273438,
        scaleX: 1,
      },
      roundNarrow: {
        y: 118.15995788574219,
        scaleX: 1,
      },
      roundMedium: {
        y: 106.60490417480469,
        scaleX: 1,
      },
      roundWide: {
        y: 88.86393737792969,
        scaleX: 1,
      },
      squareNarrow: {
        y: 103.57212829589844,
        scaleX: 1,
      },
      squareMedium: {
        y: 109.5806884765625,
        scaleX: 1,
      },
      squareWide: {
        y: 102.01686096191406,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair52back',
    svg: Hair52back,
    positioning: {
      pointNarrow: {
        y: 107.85675048828125,
        scaleX: 1,
      },
      pointMedium: {
        y: 120.01397705078125,
        scaleX: 1,
      },
      pointWide: {
        y: 112.22216796875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 120.3897705078125,
        scaleX: 1,
      },
      roundMedium: {
        y: 104.72994995117188,
        scaleX: 1,
      },
      roundWide: {
        y: 118.32205200195312,
        scaleX: 1,
      },
      squareNarrow: {
        y: 108.32723999023438,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 103.92279052734375,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair54back',
    svg: Hair54back,
    positioning: {
      pointNarrow: {
        y: 105.55989074707031,
        scaleX: 0.875,
      },
      pointMedium: {
        y: 105.26530456542969,
        scaleX: 1,
      },
      pointWide: {
        y: 105.16445922851562,
        scaleX: 1.1,
      },
      roundNarrow: {
        y: 105.97404479980469,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 103.94256591796875,
        scaleX: 0.95,
      },
      roundWide: {
        y: 105.32186889648438,
        scaleX: 1.15,
      },
      squareNarrow: {
        y: 105.6016845703125,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 105.59196472167969,
        scaleX: 1,
      },
      squareWide: {
        y: 117.23674011230469,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair55back',
    svg: Hair55back,
    positioning: {
      pointNarrow: {
        y: 113.45668029785156,
        scaleX: 1,
      },
      pointMedium: {
        y: 110.50752258300781,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 109.95222473144531,
        scaleX: 1,
      },
      roundMedium: {
        y: 113.15911865234375,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 113.75021362304688,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair57back',
    svg: Hair57back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair58back',
    svg: Hair58back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair59back',
    svg: Hair59back,
    positioning: {
      pointNarrow: {
        y: 94.734619140625,
        scaleX: 1,
      },
      pointMedium: {
        y: 99.75384521484375,
        scaleX: 1,
      },
      pointWide: {
        y: 93.37127685546875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 93.53770446777344,
        scaleX: 1,
      },
      roundMedium: {
        y: 88.7412109375,
        scaleX: 1,
      },
      roundWide: {
        y: 91.64790344238281,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90.08522033691406,
        scaleX: 1,
      },
      squareMedium: {
        y: 87.274169921875,
        scaleX: 1.05,
      },
      squareWide: {
        y: 84.13383483886719,
        scaleX: 1.1,
      },
    },
  },
  {
    id: 'Hair60back',
    svg: Hair60back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 95.04119873046875,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair63back',
    svg: Hair63back,
    positioning: {
      pointNarrow: {
        y: 104.89431762695312,
        scaleX: 1,
      },
      pointMedium: {
        y: 116.17591857910156,
        scaleX: 1,
      },
      pointWide: {
        y: 109.87144470214844,
        scaleX: 1,
      },
      roundNarrow: {
        y: 116.30853271484375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 111.71221923828125,
        scaleX: 1,
      },
      roundWide: {
        y: 106.10523986816406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 113.50421142578125,
        scaleX: 1,
      },
      squareMedium: {
        y: 114.42042541503906,
        scaleX: 1,
      },
      squareWide: {
        y: 109.54641723632812,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair64back',
    svg: Hair64back,
    positioning: {
      pointNarrow: {
        y: 110.17231750488281,
        scaleX: 1,
      },
      pointMedium: {
        y: 113.08720397949219,
        scaleX: 1,
      },
      pointWide: {
        y: 108.6441650390625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 112.834716796875,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.54939270019531,
        scaleX: 1,
      },
      roundWide: {
        y: 95.9561767578125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 104.2298583984375,
        scaleX: 1,
      },
      squareMedium: {
        y: 90.07524108886719,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair65back',
    svg: Hair65back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair66back',
    svg: Hair66back,
    positioning: {
      pointNarrow: {
        y: 121.58375549316406,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 128.31378173828125,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 124.41159057617188,
        scaleX: 1,
      },
      squareNarrow: {
        y: 127.69285583496094,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair67back',
    svg: Hair67back,
    positioning: {
      pointNarrow: {
        y: 87.46487426757812,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 89.44760131835938,
        scaleX: 0.85,
      },
      pointWide: {
        y: 85.96609497070312,
        scaleX: 0.95,
      },
      roundNarrow: {
        y: 91.21649169921875,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 90.50210571289062,
        scaleX: 0.9,
      },
      roundWide: {
        y: 87.34349060058594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 86.73931884765625,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 88.06202697753906,
        scaleX: 0.9,
      },
      squareWide: {
        y: 89.70819091796875,
        scaleX: 0.95,
      },
    },
  },
  {
    id: 'Hair68back',
    svg: Hair68back,
    positioning: {
      pointNarrow: {
        y: 108.12281799316406,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 99.63168334960938,
        scaleX: 1,
      },
      roundNarrow: {
        y: 121.27545166015625,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 115.26571655273438,
        scaleX: 1,
      },
      squareNarrow: {
        y: 116.24122619628906,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair69back',
    svg: Hair69back,
    positioning: {
      pointNarrow: {
        y: 73.91136169433594,
        scaleX: 0.85,
      },
      pointMedium: {
        y: 116.69132995605469,
        scaleX: 1,
      },
      pointWide: {
        y: 87.19961547851562,
        scaleX: 1,
      },
      roundNarrow: {
        y: 103.66375732421875,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 109.86878967285156,
        scaleX: 0.95,
      },
      roundWide: {
        y: 79.18115234375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 107.78323364257812,
        scaleX: 0.85,
      },
      squareMedium: {
        y: 110,
        scaleX: 0.95,
      },
      squareWide: {
        y: 100.01484680175781,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair70back',
    svg: Hair70back,
    positioning: {
      pointNarrow: {
        y: 117.6661376953125,
        scaleX: 1,
      },
      pointMedium: {
        y: 122.79338073730469,
        scaleX: 1,
      },
      pointWide: {
        y: 111.920166015625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 121.22026062011719,
        scaleX: 1,
      },
      roundMedium: {
        y: 119.65020751953125,
        scaleX: 1,
      },
      roundWide: {
        y: 116,
        scaleX: 1,
      },
      squareNarrow: {
        y: 114.76332092285156,
        scaleX: 1,
      },
      squareMedium: {
        y: 116,
        scaleX: 1,
      },
      squareWide: {
        y: 115.89680480957031,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair71back',
    svg: Hair71back,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair71front',
    svg: Hair71front,
    positioning: {
      pointNarrow: {
        y: 100,
        scaleX: 1,
      },
      pointMedium: {
        y: 100,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 100,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair72back',
    svg: Hair72back,
    positioning: {
      pointNarrow: {
        y: 54.02989196777344,
        scaleX: 0.8,
      },
      pointMedium: {
        y: 57.54692840576172,
        scaleX: 1,
      },
      pointWide: {
        y: 56.00628662109375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 63.2806396484375,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 57.587928771972656,
        scaleX: 0.9,
      },
      roundWide: {
        y: 52.03607177734375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 55.115638732910156,
        scaleX: 0.8,
      },
      squareMedium: {
        y: 55.92455291748047,
        scaleX: 1,
      },
      squareWide: {
        y: 58.12956237792969,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair73back',
    svg: Hair73back,
    positioning: {
      pointNarrow: {
        y: 95,
        scaleX: 1,
      },
      pointMedium: {
        y: 95,
        scaleX: 1,
      },
      pointWide: {
        y: 95,
        scaleX: 1,
      },
      roundNarrow: {
        y: 95,
        scaleX: 1,
      },
      roundMedium: {
        y: 95,
        scaleX: 1,
      },
      roundWide: {
        y: 95,
        scaleX: 1,
      },
      squareNarrow: {
        y: 95,
        scaleX: 1,
      },
      squareMedium: {
        y: 95,
        scaleX: 1,
      },
      squareWide: {
        y: 95,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair75back',
    svg: Hair75back,
    positioning: {
      pointNarrow: {
        y: 50.017181396484375,
        scaleX: 0.75,
      },
      pointMedium: {
        y: 51.78093719482422,
        scaleX: 0.85,
      },
      pointWide: {
        y: 44.50823974609375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 50.1649169921875,
        scaleX: 0.75,
      },
      roundMedium: {
        y: 51.031654357910156,
        scaleX: 0.85,
      },
      roundWide: {
        y: 43.49559783935547,
        scaleX: 1,
      },
      squareNarrow: {
        y: 48.19237518310547,
        scaleX: 0.75,
      },
      squareMedium: {
        y: 51.009681701660156,
        scaleX: 0.85,
      },
      squareWide: {
        y: 51.498207092285156,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair76back',
    svg: Hair76back,
    positioning: {
      pointNarrow: {
        y: 96.22444152832031,
        scaleX: 1,
      },
      pointMedium: {
        y: 100.94117736816406,
        scaleX: 1,
      },
      pointWide: {
        y: 90.222412109375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100.49462890625,
        scaleX: 1,
      },
      roundMedium: {
        y: 96.00485229492188,
        scaleX: 1,
      },
      roundWide: {
        y: 90.222412109375,
        scaleX: 1,
      },
      squareNarrow: {
        y: 94.92210388183594,
        scaleX: 1,
      },
      squareMedium: {
        y: 90.74636840820312,
        scaleX: 1,
      },
      squareWide: {
        y: 92.04595947265625,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair77back',
    svg: Hair77back,
    positioning: {
      pointNarrow: {
        y: 105.4931640625,
        scaleX: 1,
      },
      pointMedium: {
        y: 108.93788146972656,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 100,
        scaleX: 1,
      },
      roundMedium: {
        y: 106.93789672851562,
        scaleX: 1,
      },
      roundWide: {
        y: 109.33111572265625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 100,
        scaleX: 1,
      },
      squareMedium: {
        y: 114.28990173339844,
        scaleX: 1,
      },
      squareWide: {
        y: 108.18531799316406,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair78back',
    svg: Hair78back,
    positioning: {
      pointNarrow: {
        y: 92.54684448242188,
        scaleX: 1,
      },
      pointMedium: {
        y: 101.69486999511719,
        scaleX: 1,
      },
      pointWide: {
        y: 79.9027099609375,
        scaleX: 1,
      },
      roundNarrow: {
        y: 102.90667724609375,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.49249267578125,
        scaleX: 1,
      },
      roundWide: {
        y: 78.75141906738281,
        scaleX: 1,
      },
      squareNarrow: {
        y: 99.923583984375,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 99.61299133300781,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair80back',
    svg: Hair80back,
    positioning: {
      pointNarrow: {
        y: 100.20928955078125,
        scaleX: 1.05,
      },
      pointMedium: {
        y: 101,
        scaleX: 1.15,
      },
      pointWide: {
        y: 101.6580810546875,
        scaleX: 1.35,
      },
      roundNarrow: {
        y: 99.99044799804688,
        scaleX: 1.05,
      },
      roundMedium: {
        y: 101.88021850585938,
        scaleX: 1.15,
      },
      roundWide: {
        y: 101.88009643554688,
        scaleX: 1.35,
      },
      squareNarrow: {
        y: 101.11244201660156,
        scaleX: 1.1,
      },
      squareMedium: {
        y: 101,
        scaleX: 1.2,
      },
      squareWide: {
        y: 102,
        scaleX: 1.4,
      },
    },
  },
  {
    id: 'Hair81back',
    svg: Hair81back,
    positioning: {
      pointNarrow: {
        y: 106.35310363769531,
        scaleX: 0.9,
      },
      pointMedium: {
        y: 103.32994079589844,
        scaleX: 1,
      },
      pointWide: {
        y: 97.303955078125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 105.1910400390625,
        scaleX: 0.85,
      },
      roundMedium: {
        y: 106.90850830078125,
        scaleX: 0.95,
      },
      roundWide: {
        y: 100.10035705566406,
        scaleX: 1,
      },
      squareNarrow: {
        y: 105.63394165039062,
        scaleX: 0.9,
      },
      squareMedium: {
        y: 104.34722900390625,
        scaleX: 1,
      },
      squareWide: {
        y: 106.49882507324219,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair95back',
    svg: Hair95back,
    positioning: {
      pointNarrow: {
        y: 105.12770080566406,
        scaleX: 1,
      },
      pointMedium: {
        y: 118.54998779296875,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 107.89450073242188,
        scaleX: 1,
      },
      roundMedium: {
        y: 114.72140502929688,
        scaleX: 1,
      },
      roundWide: {
        y: 102.54803466796875,
        scaleX: 1.2,
      },
      squareNarrow: {
        y: 111.45895385742188,
        scaleX: 1,
      },
      squareMedium: {
        y: 118.62734985351562,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair97back',
    svg: Hair97back,
    positioning: {
      pointNarrow: {
        y: 116.23234558105469,
        scaleX: 1,
      },
      pointMedium: {
        y: 122.06939697265625,
        scaleX: 1,
      },
      pointWide: {
        y: 100,
        scaleX: 1,
      },
      roundNarrow: {
        y: 123.17462158203125,
        scaleX: 1,
      },
      roundMedium: {
        y: 100,
        scaleX: 1,
      },
      roundWide: {
        y: 122.83561706542969,
        scaleX: 1,
      },
      squareNarrow: {
        y: 116.51567077636719,
        scaleX: 1,
      },
      squareMedium: {
        y: 100,
        scaleX: 1,
      },
      squareWide: {
        y: 100,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Hair98back',
    svg: Hair98back,
    positioning: {
      pointNarrow: {
        y: 42.069190979003906,
        scaleX: 1,
      },
      pointMedium: {
        y: 41.992576599121094,
        scaleX: 1,
      },
      pointWide: {
        y: 44.20187759399414,
        scaleX: 1.15,
      },
      roundNarrow: {
        y: 39.81414031982422,
        scaleX: 1,
      },
      roundMedium: {
        y: 47.351524353027344,
        scaleX: 1,
      },
      roundWide: {
        y: 41.89098358154297,
        scaleX: 1.25,
      },
      squareNarrow: {
        y: 43.60578155517578,
        scaleX: 1,
      },
      squareMedium: {
        y: 44.15961456298828,
        scaleX: 1,
      },
      squareWide: {
        y: 39.49269104003906,
        scaleX: 1.25,
      },
    },
  },
]

export default data
